export default "__VITE_PUBLIC_ASSET__63cac02f__"